import { stickersOnboardingActionTypes } from './constants';

export const sendStickersOnboardedRequest = () => ({
	type: stickersOnboardingActionTypes.SEND_STICKERS_ONBOARDED_REQUEST,
});

export const sendStickersOnboardedSuccess = () => ({
	type: stickersOnboardingActionTypes.SEND_STICKERS_ONBOARDED_SUCCESS,
});

export const sendStickersOnboardedError = () => ({
	type: stickersOnboardingActionTypes.SEND_STICKERS_ONBOARDED_ERROR,
});
